(function(){
  var gal = document.querySelector('.pdp [data-lits-gallery]');
  if(!gal){ return; }
  var mainImg = gal.querySelector('.gallery-main img');
  var strip = gal.querySelector('.gallery-thumbs');
  if(!mainImg){ return; }
  var existing = strip ? strip.querySelectorAll('.thumb').length : 0;
  var path = location.pathname.split('/products/')[1] || '';
  var handle = path.split('/')[0].split('?')[0];
  if(!handle){ return; }
  function sized(src, w){
    if(!src){ return src; }
    if(src.charAt(0) === '/' && src.charAt(1) === '/'){ src = 'https:' + src; }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(p){
      var list = p.media || [];
      var media = [];
      for(var k = 0; k < list.length; k++){ if(list[k].media_type === 'image'){ media.push(list[k]); } }
      if(media.length <= existing || media.length <= 1){ return; }
      if(!strip){ strip = document.createElement('div'); strip.className = 'gallery-thumbs'; gal.appendChild(strip); }
      strip.innerHTML = '';
      var thumbs = [];
      for(var i = 0; i < media.length; i++){
        var m = media[i];
        var d = document.createElement('div');
        d.className = 'thumb' + (i === 0 ? ' active' : '');
        d.setAttribute('data-full', sized(m.src, 1200));
        var img = document.createElement('img');
        img.src = sized(m.src, 240);
        img.setAttribute('alt', (m.alt || p.title || '') + ', photo ' + (i + 1));
        img.setAttribute('loading', 'lazy');
        img.setAttribute('decoding', 'async');
        img.width = 240; img.height = 240;
        d.appendChild(img);
        strip.appendChild(d);
        thumbs.push(d);
      }
      function cur(){ for(var j = 0; j < thumbs.length; j++){ if(thumbs[j].className.indexOf('active') > -1){ return j; } } return 0; }
      function show(n){
        n = (n + thumbs.length) % thumbs.length;
        var full = thumbs[n].getAttribute('data-full');
        if(full){ mainImg.src = full; mainImg.removeAttribute('srcset'); }
        for(var q = 0; q < thumbs.length; q++){ thumbs[q].className = 'thumb' + (q === n ? ' active' : ''); }
        if(thumbs[n].scrollIntoView){ thumbs[n].scrollIntoView({ inline: 'nearest', block: 'nearest' }); }
      }
      function bindThumb(idx){ thumbs[idx].addEventListener('click', function(){ show(idx); }); }
      for(var t = 0; t < thumbs.length; t++){ bindThumb(t); }
      var arrows = ['.g-prev', '.g-next'];
      for(var a = 0; a < arrows.length; a++){ var b = gal.querySelector(arrows[a]); if(b){ b.parentNode.replaceChild(b.cloneNode(true), b); } }
      var gp = gal.querySelector('.g-prev');
      var gn = gal.querySelector('.g-next');
      if(gp){ gp.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(cur() - 1); }); }
      if(gn){ gn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(cur() + 1); }); }
      function warm(){
        var idxs = [cur() + 1, cur() - 1];
        for(var w2 = 0; w2 < idxs.length; w2++){
          var kk = (idxs[w2] + thumbs.length) % thumbs.length;
          var u = thumbs[kk].getAttribute('data-full');
          if(u){ var im = new Image(); im.decoding = 'async'; im.src = u; }
        }
      }
      if(window.requestIdleCallback){ requestIdleCallback(warm, { timeout: 2500 }); } else { setTimeout(warm, 1500); }
    })['catch'](function(){});
})();